<div class="d-flex  justify-content-center mt-5">
    <div class="bg-secondary shadow w-25 p-3 rounded">
     <form class="text-white">
        <h2 class="text-center">Login</h2>
      Enter Your Email <input class="form-control" type="text" name="" id="">
      <pre></pre>
      Enter Your Password <input class="form-control" type="password" name="" id="">
      <br>
      <div class="text-center"><button class="btn btn-primary" routerLink="/adminSubmit">Submit</button></div>
     </form>
    </div>
</div>
